import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_LoaderRow} from "../PA.Core/PAdbSchemaRows";

import {PAdbContext} from "../PA.Core/PAdbContext";
import { esWB_Loader } from "../PA.Core/PAdbSchema";
import {LoaderBO} from "./LoaderBO";


export class LoaderBOValidations {

    static async Validation(aBO: LoaderBO): Promise<void> {


        let dbContext = new PAdbContext({})

        let customerRows: WB_LoaderRow[] = await dbContext.findAll(esWB_Loader,
            {where: {DELETED_IND: {neq: '1'},
                    WB_LOADER_ID : {neq: aBO.WB_Loader.cif.WB_LOADER_ID},
                    LOADER_ID: aBO.WB_Loader.cif.LOADER_ID,
                    WB_MDSET_ID: aBO.WB_Loader.cif.WB_MDSET_ID,
                }})
        if (customerRows.length)
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'loaderalreadyexits',
                    type: MessageType.Error,
                    title: "Loader already exits in this Master Data Set",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        else
            aBO.ValidateMessageProvider.removeMessage('loaderalreadyexits')

    }

}
